module.exports = __webpack_public_path__ + "static/media/FiraSans-ThinItalic.68cf3ce6.ttf";